import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { ROUTES } from '../store/constants'

const ProtectedRoute = ({ children }) => {

    const location = useLocation()

    const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    const hasLoggedOut = useSelector(state => state.auth.hasLoggedOut)

    if (!isAuthenticated) {
        if (hasLoggedOut) {
            return <Navigate to={ROUTES.LOGIN} replace />
        }
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
    }

    return children
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired
}

export default ProtectedRoute